import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { PatientCareCenterNoteObjectiveMuskuloRow } from 'PatientCareCenter/Note/Objective/Musculoskeletal';
import styles from './Common.module.css';
import { AddButton, DBCheckBox } from '_components';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class PatientCareCenterNoteObjectiveMuskulo extends React.Component {

    addMuskulo() {
        this.props.addChildRow(this.props.noteId, 'PTOBJECTIVEPEDSMUSCU', 'PM', 'PMOPNO', this.props.opno);
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='obj_musc' name='Musculoskeletal' level={1}>
            <div className={styles.row}>
                <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDS'
                        entityKeyColumn='OPNO'
                        entityKeyValue={this.props.opno}
                        field='OPMUNOTCOMPLETED'
                        className={styles.checkbox}
                        label='Isolated strength testing not completed due to paitent age, ability to follow directions, and/or limited selective motor control'
                    />
                </div>

                <div className={styles.row}>
                        <div className={styles.add_button} >
                            <AddButton title='Motion' size='extra-small' onClick={() => this.addMuskulo()} />
                        </div>
                        
                        <span>
                        <div className={styles.column_header}>Motion</div>
                            <div className={styles.column_header}>AROM</div>
                            <div className={styles.column_header}>PROM</div>
                            <div className={styles.column_header}>Strength</div>
                        </span>
                        
                    </div>
                    {Object.keys(this.props.mobEntries)
                        .map(key => {
                            const result = this.props.mobEntries[key];
                            return (
                                <PatientCareCenterNoteObjectiveMuskuloRow key={result.PMNO} id={result.PMNO} />
                            )
                        })
                    }
            </PatientCareCenterNoteSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch)
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        mobEntries: Object.keys(state.entities.notes.PTOBJECTIVEPEDSMUSCU)
        .filter(key => { return state.entities.notes.PTOBJECTIVEPEDSMUSCU[key].PMOPNO === opno })
        .sort((a, b) => state.entities.notes.PTOBJECTIVEPEDSMUSCU[a].PMNO - state.entities.notes.PTOBJECTIVEPEDSMUSCU[b].PMNO)
        .map(key => state.entities.notes.PTOBJECTIVEPEDSMUSCU[key]),
        opno
    };
}

const connectedPatientCareCenterNoteObjectiveMuskulo = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveMuskulo);
export { connectedPatientCareCenterNoteObjectiveMuskulo as PatientCareCenterNoteObjectiveMuskulo };